export const AboutUsPageContent = {
  title: "O nas",
  paragraphs: [
    "inspektomat.pl to platforma, która pomaga znaleźć wykonawców przeglądów bezpieczeństwa budynku na terenie całej Polski. Łączymy właścicieli nieruchomości, zarządców, administratorów i biura nieruchomości z firmami realizującymi kontrole wymagane przez przepisy albo potrzebne przy bieżącej eksploatacji obiektu.",
    "Zamiast szukać specjalistów osobno w każdym mieście, możesz zacząć od rodzaju usługi albo lokalizacji i szybciej przejść do porównania dostępnych opcji. Serwis porządkuje usługi związane z elektryką, gazem, kominami, wentylacją, ochroną przeciwpożarową i stanem technicznym budynków.",
    "Naszym celem jest skrócenie drogi od obowiązku lub problemu technicznego do konkretnego działania: wyboru usługi, znalezienia firmy i zamówienia przeglądu w odpowiednim miejscu.",
  ],
  highlightsTitle: "Na platformie znajdziesz między innymi:",
  highlights: [
    "przeglądy instalacji elektrycznej, odgromowej i pomiary elektryczne",
    "kontrole gazowe, próby szczelności i serwis kotłów",
    "usługi kominiarskie, wentylacyjne i przeciwpożarowe",
    "przeglądy budowlane oraz strony miejskie z lokalną dostępnością usług",
  ],
  closing:
    "To rozwiązanie dla osób, które chcą szybciej uporządkować obowiązkowe przeglądy i znaleźć wykonawcę bez obdzwaniania rynku.",

  seo: {
    title: "O nas",
    description:
      "Platforma porównująca oferty firm wykonujących przeglądy bezpieczeństwa budynku w całej Polsce. Znajdź wykonawcę usług elektrycznych, gazowych, kominowych, wentylacyjnych, ppoż. i budowlanych.",
  },
};
